var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageView',{attrs:{"title":"专家年度评价"}},[_c('template',{slot:"action"},[_c('a-button-group',[_c('a-button',{staticClass:"intro-JiGuanShiWu-add",attrs:{"introKey":"JiGuanShiWu-add","type":"primary","icon":"plus"},on:{"click":_vm.onAdd}},[_vm._v("\n        登记\n      ")])],1)],1),_c('ExpertYearAssessSTable',{attrs:{"isManager":_vm.isManager}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }